import {JanglInputController as controller} from './controller.js';
import templateUrl from './template.html';

export const janglInputComponent = {
    templateUrl: templateUrl,
    controller: controller,
    bindings: {
        // error messages [ array { type: 'required', msg: 'This field is required.'}]
        // type correlates to form.inputName.$error keys.
        errorMessages: '<',
        // pass in a refernce to the form form the parent for validation.
        form: '=',
        // label to use for the field
        label: '@',
        // model to bind
        model: '=',
        // element name
        name: '@',
        // pattern validator, do not include regex / / wrappers, \d+\s.*, is sufficient 
        pattern: '@',
        // apply a mask on an input field so the user can only type pre-determined pattern
        mask: '@',
        // placeholder
        placeholder: '@',
        // whether the field should be required, this will not be tested, unless validate is true
        required: '<',
        // field type
        type: '@',
        // step type for decimal fields
        step: '@',
        // Disable input
        disabled: '@',
    }
}

export default janglInputComponent;


// WEBPACK FOOTER //
// ./app/jangl/jangl-input/component.js